import flatten from 'flat';
import monitor from './en-US/monitor';

export default flatten({ ...monitor });
